import { organizationLocales as commonOrganizationLocales } from '../../../common/modules/organization/locales'

const en = {
  "organizationLocales": {
    "organization": "Organization",
    "organizations": "Organizations",
    "editOrganization": "Edit organization",
    "createOrganization": "Create organization",
    "name": "Organization name",
    "fromEmails": "From emails",
    "logos": "logos",
    "logo": "logo",
    "defaultGalleryCredit": "Default gallery credit",
    "distributionBcc": "Distribution Bcc",
    "domain": "Sub Domain",
    "clientApp": "Client app",
    "designPreferences": "Design preferences",
    "loginPagePreferences": "Login page preferences",
    "loginPageBgImage": "login page background image",
    "loginBgImg": "Login page bg img",
    "loginPageMsg": "Login page msg",
    "bodyColor": "Text color",
    "bodyBg": "Bsckground color",
    "headerColor": "Header text color",
    "headerBg": "Header background color",
    "headersColor": "Headings text color",
    "linkColor": "Links color",
    "btnColor": "Buttons color",
    "headersBgColor": "Headings bg color",
    "domainTakenError": "Domain is alredy taken by another organization!",
    "inviteMembers": "Invite members",
    "searchOrganizations": "Search organization",
    "addOrganization": 'Add organization',
    "mediaLinks": "Media",
    "requireAuth": "Require authentication",
    "require2FactorAuth": "Require 2nd factor authentication",
    "useVideoWaterMark": "Use video watermark",
    "useBurnedInWatermark": "Use burned-in video watermark",
    "burnedInWatermarkText": "Burned-in watermark text",
    "organizationSettings": "Organization settings",
    "featureFlags": "Feature Flags",
    "encryptedVideosSection": "Enable encrypted videos section",
    "releaseLevel2FA": "Enable release-level 2FA",
    "itemLevelPermissions": "Enable item-level permissions",
    "storageConfiguration": "Storage Configuration",
    "imagesBucketConfig": "Images bucket config",
    "videosBucketConfig": "Videos bucket config",
    "useSignedUrls": "Use signed URLs for CloudFront",
    "bucketConfigPlaceholder": "e.g., 'hot-stream', 'yes'",
    "videoEncodingPreset": "Video encoding preset",
    "videoEncodingPreset720p": "720p (1 Mbps)",
    "videoEncodingPreset1080p": "1080p (2.5 Mbps)",
    "videoEncodingPresetAuto": "Auto (MediaConvert optimized)",
    "videoEncodingPresetPassthrough": "Same as input file (preserve original quality)",
    "orgRoles": {
      ...commonOrganizationLocales.en.organizationLocales.orgRoles,
      "creator": "Creator",
      "admin": "Admin",
      "producer": "Producer",
      "user": "User",
      "client": "Watch only",
      "developer": "Developer"
    },
    "alerts": {
      "confirmRemove": "Are you sure you want to remove this organization?",
      "removeSuccess": "Organization removed successfully",
      "savedSuccess": "Organization saved successfully",
      "invetationSentSuccess": "Invetation sent successfully",
      "requestSentSuccess": "Request sent successfully",
      "confirmAccountApproval": "Are you sure you want to approve this account to join the organization?"
    },
    "approveJoin": "Approve join",
    "saveOrgToUploadFilesMsg": "Save organization in order to upload files",
    "design": "Design",
    "design-landingPage": "Landing page design",
    "design-email": "Newsletter design",
    "allowDesignSelection": "Allow design selection",
    "contactMsg": "Contact details",

    "designPreferencesTypes": {
      "producerApp": "Producer app",
      "clientApp": "client app",
      "newsletter": "Newsletter"
    }

    ,
    "templateWizard": {
      "title": "Release template wizard (new org)",
      "enableSchemaModeForOrg": "Enable schema mode for this org",
      "startModeLabel": "Start mode",
      "startBlank": "Blank",
      "startFromDefaultTemplate": "Based on default template",

      "stage1ChooseElements": "Stage 1: choose elements",
      "stage1TitleField": "Title field",
      "stage1SubTitleField": "Subtitle field",
      "stage1MainImageField": "Main image field",
      "stage1ContentField": "Content field",
      "stage1SectionsField": "Sections",

      "stage1SectionTypeTextItems": "Text items",
      "stage1SectionTypeImages": "Images",
      "stage1SectionTypeVideos": "Videos",
      "stage1SectionTypeLinks": "Links",

      "stage2LabelsAndShowHide": "Stage 2: labels + show/hide",
      "stage2Label": "Label",
      "stage2ShowTitle": "Show title",

      "stage3SectionsOrder": "Stage 3: sections/tabs order",

      "elements": {
        "section": {
          "textItems": "Text items",
          "images": "Images",
          "videos": "Videos",
          "links": "Links"
        }
      }
    },
    "releaseTitleValueVisibility": {
      "showTitleValue": "Show title value"
    }
  },
  "musicArtistLocales": {
    "artistSettings": "Artist settings",
    "createArtist": "Create artist",
    "artistName": "Artist name",
  }
}
const he = {
  "organizationLocales": {
    "organization": "ארגון",
    "organizations": "ארגונים",
    "editOrganization": "ערוך פרטי ארגון",
    "createOrganization": "צור ארגון חדש",
    "newPassword": "סיסמה חדשה",
    "unBlock": "בטל חסימה",
    "name": "שם האירגון",
    "fromEmails": "כתובות דוא״ל מהן מופץ הרליס",
    "logos": "לוגואים",
    "logo": "לוגו",
    "defaultGalleryCredit": "ברירת מחדל לקרדיט גלריה",
    "distributionBcc": "הפצה bcc",
    "domain": "תת דומיין",
    "clientApp": "אפליקציית לקוח",
    "designPreferences": "העדפות עיצוב",
    "loginPagePreferences": "העדפות דף התחברות",
    "loginPageBgImage": "תמונת רקע",
    "loginBgImg": "צבע רקע",
    "loginPageMsg": "הודעה",
    "bodyColor": "צבע טקסט",
    "bodyBg": "צבע רקע",
    "headerColor": "צבע טקסט הדר",
    "headerBg": "צבע רקע הדר",
    "headersColor": "צבע כותרים",
    "linkColor": "צבע קישורים",
    "btnColor": "צבע כפתורים",
    "headersBgColor": "צבע רקע כותרים",
    "domainTakenError": "הדומיין הזה כבר בשימוש באירגון אחר!",
    "inviteMembers": "הזמן משתמשים",
    "searchOrganizations": "חפש ארגון",
    "addOrganization": 'הצטרף לארגון',
    "mediaLinks": "מדיה",
    "requireAuth": "דרושה הזדהות",
    "require2FactorAuth": "דרושה הזדהות נוספת",
    "useVideoWaterMark": "ווטרמארק על וידאו",
    "useBurnedInWatermark": "ווטרמארק צרוב על וידאו",
    "burnedInWatermarkText": "טקסט לווטרמארק הצרוב",
    "organizationSettings": "הגדרות ארגון",
    "featureFlags": "דגלי תכונות",
    "encryptedVideosSection": "אפשר סעיף וידאו מוצפן",
    "releaseLevel2FA": "אפשר אימות דו-שלבי ברמת רליס",
    "itemLevelPermissions": "אפשר הרשאות ברמת פריט",
    "storageConfiguration": "הגדרות אחסון",
    "imagesBucketConfig": "תצורת bucket לתמונות",
    "videosBucketConfig": "תצורת bucket לוידאו",
    "useSignedUrls": "השתמש ב-URLs חתומים ל-CloudFront",
    "bucketConfigPlaceholder": "לדוגמה: 'hot-stream', 'yes'",
    "videoEncodingPreset": "פרסט קידוד וידאו",
    "videoEncodingPreset720p": "720p (1 Mbps)",
    "videoEncodingPreset1080p": "1080p (2.5 Mbps)",
    "videoEncodingPresetAuto": "אוטומטי (מותאם על ידי MediaConvert)",
    "videoEncodingPresetPassthrough": "זהה לקובץ המקור (שמור על איכות מקורית)",
    "orgRoles": {
      ...commonOrganizationLocales.he.organizationLocales.orgRoles,
      "creator": "יוצר",
      "admin": "אדמין",
      "producer": "מפיץ",
      "user": "משתמש",
      "client": "צפיה",
      "developer": "מפתח"
    },
    "alerts": {
      "confirmRemove": "האם אתה בטוח שאתה רוצה למחוק את הארגון?",
      "removeSuccess": "ארגון נמחק בהצלחה",
      "savedSuccess": "פרטי ארגון נשמרו בהצלחה",
      "invetationSentSuccess": "הזמנה נשלחה בהצלחה",
      "requestSentSuccess": "בקשה נשלחה בהצלחה",
      "confirmAccountApproval": "האם אתה בטוח שאתה מעוניין לאשר את הצטרפות המשתמש לארגון?"
    },
    "approveJoin": "אשר הצטרפות",
    "saveOrgToUploadFilesMsg": "שמור את הארגון על מנת להעלות קבצים",
    "design": "עיצוב",
    "design-landingPage": "עיצוב דף נחיתה",
    "design-email": "עיצוב מייל הפצה",
    "allowDesignSelection": "אפשר לבחור עיצוב",
    "contactMsg": "פרטים ליצירת קשר",

    "designPreferencesTypes": {
      "producerApp": "אתר הפצה",
      "clientApp": "דף נחיתה",
      "newsletter": "ניוזלטר"
    },

    "templateWizard": {
      "title": "אשף תבנית רליס (ארגון חדש)",
      "enableSchemaModeForOrg": "הפעל מצב תבנית עבור ארגון זה",
      "startModeLabel": "מצב התחלה",
      "startBlank": "ריק",
      "startFromDefaultTemplate": "מבוסס על תבנית ברירת מחדל",

      "stage1ChooseElements": "שלב 1: בחר מרכיבים",
      "stage1TitleField": "שדה כותרת",
      "stage1SubTitleField": "שדה כותרת משנה",
      "stage1MainImageField": "שדה תמונה ראשית",
      "stage1ContentField": "שדה תוכן",
      "stage1SectionsField": "מקטעים",

      "stage1SectionTypeTextItems": "טקסטים",
      "stage1SectionTypeImages": "תמונות",
      "stage1SectionTypeVideos": "וידאו",
      "stage1SectionTypeLinks": "קישורים",

      "stage2LabelsAndShowHide": "שלב 2: כותרות ותצוגה",
      "stage2Label": "כותרת",
      "stage2ShowTitle": "הצג כותרת",

      "stage3SectionsOrder": "שלב 3: סדר מקטעים וטאבים",

      "elements": {
        "section": {
          "textItems": "טקסטים",
          "images": "תמונות",
          "videos": "וידאו",
          "links": "קישורים"
        }
      }
    },
    "releaseTitleValueVisibility": {
      "showTitleValue": "הצג כותרת"
    }
  },
  "musicArtistLocales": {
    "artistSettings": "הגדרות אמן",
    "createArtist": "צור אמן",
    "artistName": "שם אמן",
  }
}
const heF = {
  ...he,
  organizationLocales: {
    ...he.organizationLocales,
    "editOrganization": "ערכי פרטי ארגון",
    "createOrganization": "צרי ארגון חדש",
    "inviteMembers": "הזמיני משתמשים",
    alerts: {
      ...he.organizationLocales.alerts,
      "confirmRemove": "האם את בטוחה שאת רוצה למחוק את הארגון?",
    }
  },
  musicArtistLocales: {
    ...he.musicArtistLocales
  }
}

export const organizationLocales = {
  en,
  he,
  heF
}